// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import LoadingSpinner from 'Components/LoadingSpinner';
import React, { useEffect, useState } from 'react';
import stylesDef from './styles';
import { GetOrdersThunk } from 'Features/order/orderThunk';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { useParams } from 'react-router-dom';
import SearchField from 'Components/SearchField';
import moment from 'moment';
import OrderAdjustmentCard from './orderAdjustmentCard';
import { GetOrderAdjustmentsThunk, GetOrgThunk } from '../adminThunk';
import { RootState } from 'Store';
import { SetOrgIdAction } from '../adminActions';

const OrderAdjustments: React.FC = () => {
  // Constants
  const theme = useTheme();
  const styles = stylesDef(theme);
  const dispatch = useAppDispatch();
  const { orgId } = useParams();
  const orderAdjustmentsDetails = useAppSelector((state: RootState) => state.admin.orderAdjustmentsDetails);

  // State Variables
  const [showLoader, setShowLoader] = useState(false);

  //useEffects
  useEffect(() => {
    loadData();
  }, []);

  //Methods
  const loadData = async (searchQuery?: string) => {
    setShowLoader(true);
    if (_ADMIN_) {
      await Promise.all([
        dispatch(GetOrgThunk(orgId)),
        dispatch(SetOrgIdAction(orgId))
      ]);
    } 
    await dispatch(GetOrderAdjustmentsThunk(searchQuery));
    setShowLoader(false);
  };

  return (
    <LoadingSpinner loading={showLoader}>
      <Box sx={styles.pageWrapper}>
        <Box sx={styles.itemsWrapper}>
            <SearchField
              sx={styles.icons}
              placeholder="Search"
              debounceTimeout={500}
              onChange={(value) => loadData(value)}
            />
          </Box>
          <Divider sx={styles.divider} />
          {orderAdjustmentsDetails?.map((item) => (
            <OrderAdjustmentCard key={item.projectId} orderAdjustment={item} />
          ))}
      </Box>
    </LoadingSpinner>
  );
};

export default OrderAdjustments;
